<template>
 <div class="block block__theme_header"
      :class="(marginTop === 'mobile')?('block__style_margin_top'):('')"
 >
   <div class="step">
     {{ `Шаг ${currentStep}/${countStep}` }}
   </div>

   <div class="title">
     {{ title }}
   </div>
 </div>
</template>

<script>
export default {
  name: "MobileStepInfo",

  props: {
    title: { // Наименование этапа
      type: String,
      default: () => {
        return '';
      }
    },

    countStep: { // кол-во шагов всего
      type: Number,
      default: () => {
        return 7
      }
    },

    currentStep: { // текущий шаг
      type: Number,
      default: () => {
        return 1
      }
    },

    marginTop: {
      type: String,
      default: () => {
        return 'mobile'
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../style/variables";

.block__theme_header {
  display: flex;
  flex-direction: column;
}

.step {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: $color_purple_3;
}

.title {
  margin-top: 1px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 120%;
}

.block__style_margin_top {
  margin-top: 21px;
}

</style>